import React from 'react';
import './WhyUs.css';

const WhyUs = () => {
  const reasons = [
    {
      title: 'DEEP UE & VR EXPERTISE',
      description: 'We build realistic, high-performance environments with accurate physics and intuitive interaction. Your team trains in conditions that mirror the real world.'
    },
    {
      title: 'SIMULATION-READY EXPERIENCE',
      description: "For almost 8 years, we've delivered safety, medical, and educational VR projects that demand precision and reliability. We know how to turn real processes into clear, repeatable training."
    },
    {
      title: 'HIGH-END PRODUCTION',
      description: 'Virtual production for Karate Kombat and full-cycle development of Boss Fighters show our ability to execute large, technically challenging projects without compromise.'
    },
    {
      title: 'TRANSPARENT COLLABORATION',
      description: "We keep communication open, decisions clear, and production organized. You always know where the project stands and what's coming next — making the whole workflow easier for everyone involved."
    }
  ];

  return (
    <div 
      className="container-fluid fh5co-content-box"
      id="why-us-wrapper"
      style={{
        position: 'relative',
        width: '100%',
        backgroundColor: '#111111'
      }}
    >
      <div className="container-fluid px-5" style={{position: 'relative'}}>
        <div id="why-us">
          <div className="row">
            <div className="col-12 text-center">
              <div className="quote-box2 wow bounceInDown" data-wow-delay=".25s">
                <h2 style={{color: '#ff6600'}}>WHY US</h2>
              </div>
            </div>
          </div>
          <div className="row">
            {reasons.map((reason, index) => (
              <div key={index} className="col-md-3">
                <div className={`card text-left wow ${index === 0 ? 'bounceInLeft' : index === 1 ? 'bounceInUp' : index === 2 ? 'bounceInRight' : 'bounceInDown'}`} 
                     data-wow-delay=".25s">
                  <div className="card-body mb-5">
                    <div className="card-title-wrapper">
                      <div className="orange-square"></div>
                    <h4 className="card-title">{reason.title}</h4>
                    </div>
                    <p className="card-text">{reason.description}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUs;

